import * as React from 'react'
import { Link, browserHistory } from 'react-router'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { Routes } from '../../../../constants/Routes'

import { axios } from '@getgreenline/homi-shared'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
}

@inject('currentCompanyStore')
@observer
export class QuickBooksAuthConnect extends React.Component<Props, {}> {
  componentDidMount() {
    const company = this.props.currentCompanyStore!.company!
    if (company.hasQuickBooksAuthToken) {
      browserHistory.push(Routes.DASHBOARD_INTEGRATIONS_QUICKBOOKS_ONLINE_SETTINGS(company.id))
    }
  }

  onClick = () => {
    axios
      .get(`/api/v1/company/${this.props.currentCompanyStore!.company!.id}/quickBooks/requestToken`)
      .then((response) => {
        const authUri = response.data.authUri
        window.open(authUri, '_blank')
      })
      .catch((error) => {
        console.error(error)
      })
  }

  render() {
    return (
      <>
        <div className='text-muted'>
          Please make sure pop-ups and redirects are not blocked by the browser
        </div>
        <div style={{ width: '300px', cursor: 'pointer' }} onClick={this.onClick}>
          <img
            className='w-100'
            src={
              require('../../../../images/quick-books-online/C2QB_green_btn_lg_default.png').default
            }
          />
        </div>
      </>
    )
  }
}
